import {
  WallStructureDTO,
  WallStructureDTORowKeyEnum,
} from "~/api/webservice/index";
import { camelize } from "~/utils/strings";

const DEFAULT_IMAGE =
  "https://via.placeholder.com/150.png?text=External+insulation";

/** */
export class WallStructure {
  readonly type: WallStructureDTORowKeyEnum;
  readonly name: string;
  readonly thicknesses: NonNullable<WallStructureDTO["thicknesses"]> | null;
  readonly imageURL: string = DEFAULT_IMAGE;
  readonly timestamp: WallStructureDTO["timestamp"];

  constructor(data: WallStructureDTO) {
    this.type = data.rowKey;

    const camelizedType = camelize(this.type);

    this.name = `selectView.insType.types.${camelizedType}`;
    this.thicknesses = data.thicknesses || null;
    this.timestamp = data.timestamp;

    try {
      this.imageURL = `./assets/wallStructures/${camelizedType}.png`;
    } catch (e) {
      console.warn(
        `The image "${camelizedType}" cannot be found for "${this.type}" WallStructure`
      );
    }
  }

  get hasThicknesses(): boolean {
    return !!this.thicknesses;
  }

  get camelizedType(): string {
    return this.camelizedType;
  }
}
